module.exports = __webpack_public_path__ + "img/browser.12b3e539.svg";